import { render } from "./DonationAppealsTab.vue?vue&type=template&id=9cd71e1a"
import script from "./DonationAppealsTab.vue?vue&type=script&lang=js"
export * from "./DonationAppealsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__